import { useRemoteSubscriberWalletCredits } from './useRemoteSubscriberWalletCredits';

/**
 * When a creator auto-places an outgoing call, verify the subscriber has enough credits
 * (unless pricing came from the rate modal / query override).
 */
export function useCreatorOutgoingSubscriberCredits({
  isCreator,
  shouldAutoPlaceCall,
  creatorOutgoingPricing,
  callRateOverride,
  targetSubscriberId,
}) {
  const shouldVerifySubscriberCreditsForCreatorOutgoing =
    Boolean(isCreator && shouldAutoPlaceCall && creatorOutgoingPricing?.ok) && !callRateOverride;

  const canFetchRemoteCredits =
    shouldVerifySubscriberCreditsForCreatorOutgoing && Boolean(targetSubscriberId);

  const { credits, loading, error } = useRemoteSubscriberWalletCredits(targetSubscriberId, {
    enabled: canFetchRemoteCredits,
  });

  const creatorOutgoingCreditsPending =
    Boolean(shouldVerifySubscriberCreditsForCreatorOutgoing) &&
    (!targetSubscriberId || loading || (credits == null && !error));

  const creatorBlockedForSubscriberCredits =
    Boolean(shouldVerifySubscriberCreditsForCreatorOutgoing) &&
    !creatorOutgoingCreditsPending &&
    Number.isFinite(credits) &&
    credits < creatorOutgoingPricing.minCostCredits;

  return {
    remoteSubscriberCredits: credits,
    remoteSubscriberCreditsLoading: loading,
    remoteSubscriberCreditsError: error,
    creatorOutgoingCreditsPending,
    creatorBlockedForSubscriberCredits,
  };
}
